import React, { useState } from 'react';
import './sliderCalendar.css';

const SliderCalendar = () => {
    // Get today's date
    const today = new Date();
    
    // State to store the currently selected date
    const [selectedDate, setSelectedDate] = useState(today);
  
    // Helper function to get the start of the week (Sunday)
    const getWeekDates = (date) => {
      const startOfWeek = new Date(date);
      startOfWeek.setDate(date.getDate() - date.getDay()); // Set to Sunday
      const week = [];
      for (let i = 0; i < 7; i++) { // Loop through 7 days (Sunday to Saturday)
        week.push(new Date(startOfWeek));
        startOfWeek.setDate(startOfWeek.getDate() + 1); // Increment date
      }
      return week;
    };
  
    // Get the week dates for display
    const [weekDates, setWeekDates] = useState(getWeekDates(today));
  
    // Handle the click to select a date
    const handleDateClick = (date) => {
      setSelectedDate(date);
    };
  
    // Scroll to the previous week
    const goToPreviousWeek = () => {
      const newStartDate = new Date(weekDates[0]);
      newStartDate.setDate(newStartDate.getDate() - 7);
      setWeekDates(getWeekDates(newStartDate));
    };
  
    // Scroll to the next week
    const goToNextWeek = () => {
      const newStartDate = new Date(weekDates[0]);
      newStartDate.setDate(newStartDate.getDate() + 7);
      setWeekDates(getWeekDates(newStartDate));
    };
  
    return (
      <div className="week-slider">
        <button onClick={goToPreviousWeek} className="nav-button">{'<'}</button>
        <div className="days-container">
          {weekDates.map((date) => (
            <div
              key={date.toDateString()}
              className={`day-box ${date.toDateString() === selectedDate.toDateString() ? 'selected' : ''}`}
              onClick={() => handleDateClick(date)}
            >
              <div className="day-name">
                {date.toLocaleString('default', { weekday: 'short' })} {/* Display day name */}
              </div>
              <div className="day-number">{date.getDate()}</div> {/* Display day number */}
            </div>
          ))}
        </div>
        <button onClick={goToNextWeek} className="nav-button">{'>'}</button>
      </div>
    );
  };
  
  export default SliderCalendar;
  